export default __webpack_public_path__ + "static/media/09_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7731.78eef45b.jpg";